import ProductCard from "@components/Cards/ProductCard"
import ProductCombinationCard from "@components/Cards/ProductCombinationCard"
import { Box } from "@components/Layout"
import imgix from "@config/imgix"
import { ChoicesArticle } from "@generated"
import * as qs from "query-string"
import React from "react"
import { FilterState } from "."

const loadingItems = Array.from(Array(10)).map((u, i) => (
  <ProductCombinationCard key={`loading-${i}`} isLoading href="" />
))

interface Props {
  loading: boolean
  fetchingMore: boolean
  items: ChoicesArticle[]
  prefix: string
  href: string
  filters: FilterState
}

const Grid: React.FC<Props> = ({
  loading,
  fetchingMore,
  prefix,
  href,
  items,
  filters,
}) => {
  let args = {
    style: filters.style,
  }
  if (filters.size) {
    args["size"] = filters.size
  }
  if (filters.cut) {
    args["cut"] = filters.cut
  }
  const filterParams = encodeURIComponent(qs.stringify(args))
  return (
    <Box
      display="grid"
      gridTemplateColumns={[
        "100%",
        "repeat(3, 1fr)",
        "repeat(3, 1fr)",
        "repeat(5, 1fr)",
      ]}
      gridRowGap={["1rem", "1rem", "1.5rem"]}
      gridColumnGap={[0, "1rem", "1.5rem"]}
      data-testid="ac-grid"
    >
      {loading && !fetchingMore ? (
        loadingItems
      ) : (
        <>
          {items.map((item, key) => (
            <ProductCard
              key={key}
              href={href}
              as={`${prefix}/${item.slug}-${item.id}?overview_filters=${filterParams}`}
              image={imgix({
                key: item.id,
                type: "article",
                args: { w: 250, h: 250 },
              })}
              price={item.price}
              title={item.name}
              id={item.id}
              component={item.component}
              size={item.size}
            ></ProductCard>
          ))}
          {fetchingMore && loadingItems}
        </>
      )}
    </Box>
  )
}

export default Grid
